import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchCategories = createAsyncThunk('categoriesSlice/fetchCategories', async () => {
    const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?categories`)
    const data = await res.json()
    return data;
})

const categoriesSlice = createSlice({
    initialState: {
        categories: [],
        loading: false,
        error: null,
    },
    name: 'categoriesSlice',
    extraReducers: (builder) => {
        builder
            .addCase(fetchCategories.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchCategories.fulfilled, (state, action) => {
                state.loading = false;
                state.categories = action.payload;
            })
            .addCase(fetchCategories.rejected, (state, action) => {
                state.loading = false;
                state.error = <p className='error-api'>The server is temporarily down Please try later!</p>;
            });
    },
})

export const { } = categoriesSlice.actions;

export default categoriesSlice.reducer;